import React from 'react';

const Input = ({className, ...props}) => {
    return (
        <input {...props}
               className={` p-1 max-w-full bg-black bg-opacity-5 required:bg-yellow-500 required:bg-opacity-30 rounded shadow-inner ${className}`}/>
    );
};

export default Input;